import { Directive, Input, Output, ElementRef, EventEmitter, HostListener } from '@angular/core';

import { ProductPublicModels } from '@features/products/product';

@Directive({
    selector: '[productClick]',
    standalone: true,
})
export class ProductClickDirective {
    @Input() private readonly bannerLinks: ProductPublicModels.PublicBannerLink[];

    @Output() public readonly clickProduct = new EventEmitter<ProductPublicModels.PublicBannerLink>();

    constructor(private readonly el: ElementRef) {}

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent) {
        if (this.bannerLinks?.length) {
            const rect = this.el.nativeElement.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            const width = rect.width;
            const height = rect.height;

            const xPercent = x / width * 100;
            const yPercent = y / height * 100;
            const area = this.bannerLinks.find(bannerLinkItem =>
                this.isPointInArea(bannerLinkItem.area, { x: xPercent, y: yPercent }));
            if (area) {
                this.clickProduct.emit(area);
            }
        } else {
            this.clickProduct.emit(null);
        }
    }

    private isPointInArea(area: { x1: number; y1: number; x2: number; y2: number }, point: { x: number; y: number }) {
        return point.x >= area.x1 && point.x <= area.x2 && point.y >= area.y1 && point.y <= area.y2;
    }
}
